export default {
  INFO: 'info',
  SUCCESS: 'success',
  WARNING: 'warning',
  ERROR: 'error',
  VALIDATION_ERROR: 'validation error',
};
